import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import SelectField from './SelectField';

const MinutesSelectField = ({ id, value, options, onChange }) => {
  const minuteOptions = useMemo(
    () =>
      options.map((minutes) => ({
        value: minutes,
        labelKey: 'positionTemplate.create.additionalInfo.minutes',
        labelValues: { minutes },
      })),
    [options]
  );

  return (
    <SelectField
      id={id}
      value={value}
      options={minuteOptions}
      onChange={(next) => onChange(Number(next))}
    />
  );
};

MinutesSelectField.propTypes = {
  id: PropTypes.string,
  value: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MinutesSelectField;
